import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { getTimeZoneName } from '../../util/helpers';

const FORMATS = {
  short: 'MMM DD, YYYY',
  shortWithTime: 'MMM DD, YYYY - hh:mm A',
  shortWithTimeAt: 'MMM DD, YYYY \\a\\t hh:mm A',
  long: 'MMMM DD, YYYY',
  longWithTime: 'dddd, MMM DD, YYYY - hh:mm A',
  time: 'hh:mm A',
};

function DateTimeDisplay(props) {
  const { value, relative, maxRelativeDifferentDays, timezone, showTimezone } = props;
  let { format } = props;

  if (!value) {
    return null;
  }

  if (format && FORMATS[format]) {
    format = FORMATS[format];
  } else {
    format = format || FORMATS.short;
  }
  let m = null;
  try {
    m = moment(value);
  } catch (e) {
    m = null;
  }
  if (m === null || !m.isValid()) {
    return null;
  }
  if (relative) {
    const today = moment().startOf('day');
    const diff = today.diff(m, 'days');
    if ((diff < maxRelativeDifferentDays && diff >= 0) || maxRelativeDifferentDays < 0) {
      return (
        <span className="date-time-display">{m.fromNow()}</span>
      );
    }
  }

  let timezoneDisplay = null;
  if (showTimezone) {
    const _timezone = showTimezone ? timezone || moment.tz.guess() : null;
    const tz = getTimeZoneName(moment().tz(_timezone));
    const isLocal = timezone === null;
    timezoneDisplay = ` (${isLocal ? 'Local' : 'Server'} Timezone: ${tz})`;
  }

  return (
    <span className="date-time-display">{relative ? 'on ' : ''}{m.format(format)}{timezoneDisplay}</span>
  );
}

DateTimeDisplay.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(moment),
  ]),
  format: PropTypes.string,
  relative: PropTypes.bool,
  maxRelativeDifferentDays: PropTypes.number,
  showTimezone: PropTypes.bool,
  timezone: PropTypes.string,
};

DateTimeDisplay.defaultProps = {
  format: null,
  relative: false,
  value: null,
  maxRelativeDifferentDays: -1,
  showTimezone: false,
  timezone: null,
};

export default DateTimeDisplay;
